import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';

import Image from 'common/components/_base/Image';
import Price from 'common/components/_base/Price';
import RouteLink from 'common/components/_base/RouteLink';
import { formatPrice, formatDiscount } from 'common/utils/index';

import { StyledStackedLabels, StyledDiscountLabel } from './_styles';

const DEFAULT_BOX_SHADOW = 'box-shadow: 0 0 20px rgba(0,0,0,.2);';
const DEFAULT_BORDER = '2px solid #f0f0f0';

const StyledItem = styled.section`
  position: relative;
  display: flex;
  background: ${({ theme }) => (theme.colors ? theme.colors.white : null)};
  border: ${({ theme }) => _.get(theme, 'productCard.border', DEFAULT_BORDER)};
  width: 100%;
  padding: 10px;
  align-items: center;
  margin-bottom: 20px;
  transition: all 0.4s;
  &:hover {
    box-shadow: ${({ theme }) =>
      _.get(theme, 'productCard.hover.boxShadow', DEFAULT_BOX_SHADOW)};
  }
`;

const StyledImageLink = styled(({ children, urlTitle, ...props }) => {
  if (!_.isEmpty(urlTitle) && _.isString(urlTitle)) {
    return (
      <RouteLink route="product" params={{ id: urlTitle }} {...props}>
        {children}
      </RouteLink>
    );
  }
  return <div {...props}>{children}</div>;
})`
  && {
    display: block;
    text-decoration: none;
    width: 60px;
    height: 60px;
  }
`;

const StyledInfo = styled.section`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  padding: 0 10px;
`;

const StyledName = styled(({ children, urlTitle, ...props }) => {
  if (!_.isEmpty(urlTitle) && _.isString(urlTitle)) {
    return (
      <RouteLink route="product" params={{ id: urlTitle }} {...props}>
        {children}
      </RouteLink>
    );
  }
  return <div {...props}>{children}</div>;
})`
  && {
    display: flex;
    font-size: 0.875em;
    font-weight: normal;
    margin-bottom: 5px;
    color: ${({ theme }) => _.get(theme, 'productCard.name.color', '#999')};
    text-decoration: none;
    line-height: 1.2;
    &:hover {
      color: ${({ theme }) => _.get(theme, 'productCard.name.color', '#999')};
    }
  }
`;

class ProductCardSmall extends PureComponent {
  render() {
    const { data, showLabels = true, customStyle } = this.props;
    if (data) {
      const {
        photo,
        name,
        urlTitle,
        finalPrice,
        finalPriceWithoutDPH,
        discount,
        price
      } = data;
      return (
        <StyledItem>
          {showLabels ? (
            <StyledStackedLabels customStyle={customStyle}>
              {discount ? (
                <StyledDiscountLabel
                  dangerouslySetInnerHTML={{
                    __html: `${formatDiscount(discount)} %`
                  }}
                  customStyle={customStyle}
                />
              ) : (
                ''
              )}
            </StyledStackedLabels>
          ) : (
            ''
          )}
          <StyledImageLink urlTitle={urlTitle}>
            {photo ? (
              <Image
                {...photo}
                size="60x60.png"
                alt={photo.title ? photo.title : name}
              />
            ) : (
              ''
            )}
          </StyledImageLink>
          <StyledInfo>
            <StyledName urlTitle={urlTitle}>{name.substring(0, 90)}</StyledName>
            <Price
              showDiscount={false}
              finalPrice={formatPrice(finalPrice)}
              finalPriceWithoutDPH={formatPrice(finalPriceWithoutDPH)}
              price={formatPrice(price)}
              discount={discount}
              showWithoutVat={false}
            />
          </StyledInfo>
        </StyledItem>
      );
    }
    return null;
  }
}

export default withTranslation()(ProductCardSmall);
